import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Vip from './pages/Vip.vue'
import Reports from './pages/Reports.vue'
import Login from './pages/Login.vue'
import Register from './pages/Register.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '卓安科技-首页'
    }
  }, {
    path: '/vip',
    name: 'vip',
    component: Vip,
    meta: {
      title: '卓安科技-VIP中心'
    }
  }, {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: {
      title: '卓安科技-行业报告'
    }
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '卓安科技-会员登录'
    }
  }, {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '卓安科技-注册会员'
    }
  }]
})